// extracted by mini-css-extract-plugin
export default {"input-digit":"InputDigit_input-digit__AtcXT","input-digit--error":"InputDigit_input-digit--error__8VjKF"};